import React from 'react';
import { useDispatch } from 'react-redux';
import {
  TextField,
  Grid
} from '@material-ui/core';
import {
  editUserStoreProduct
} from 'redux/actions/products';


const SearchEngineOptimization = ({product}) => {
  const dispatch = useDispatch();

  const metaTitle = product.custom_attributes?.find((a) => a.attribute_code === 'meta_title')?.value;
  const metaKeywords = product.custom_attributes?.find((a) => a.attribute_code === 'meta_keyword')?.value;
  const metaDescription = product.custom_attributes?.find((a) => a.attribute_code === 'meta_description')?.value;

  const editProductMetaInfo = (attrCode, newValue) => {
    const updatedProduct = {custom_attributes: product.custom_attributes.map((a) => a.attribute_code === attrCode ? {...a, value: newValue} : a)};

    dispatch(editUserStoreProduct(updatedProduct));
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12}>
        <TextField
          variant="outlined"
          className="mb-5"
          defaultValue={metaTitle}
          onBlur={(e) => editProductMetaInfo('meta_title', e.target.value)}
          fullWidth
          label={
            <div className="flex items-center">
              Meta Title
            </div>
          }
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <TextField
          variant="outlined"
          className="mb-5"
          defaultValue={metaKeywords}
          onBlur={(e) => editProductMetaInfo('meta_keyword', e.target.value)}
          fullWidth
          label={
            <div className="flex items-center">
              Meta Keywords
            </div>
          }
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <TextField
          variant="outlined"
          className="mb-5"
          defaultValue={metaDescription}
          onBlur={(e) => editProductMetaInfo('meta_description', e.target.value)}
          fullWidth
          label={
            <div className="flex items-center">
              Meta Description
            </div>
          }
        />
      </Grid>
    </Grid>
  );
};

export default SearchEngineOptimization;
